import { useLanguageData } from '@/common/hooks/useLanguageData';
import LanguageSwitcherTrigger from './components/LanguageSwitcherTrigger';
import LanguageSwitcherModal from './components/LanguageSwitcherModal';
import { useLanguageSwitcher } from './hooks/useLanguageSwitcher';

const LanguageSwitcher = () => {
	const t = useLanguageData('language');
	const {
		lang,
		open,
		currentLanguage,
		handleToggle,
		handleClose,
		handleSelect,
	} = useLanguageSwitcher();

	return (
		<>
			<LanguageSwitcherTrigger
				currentLanguageCode={currentLanguage.code}
				selectLanguageLabel={t.selectLanguage}
				open={open}
				onToggle={handleToggle}
			/>
			<LanguageSwitcherModal
				open={open}
				onClose={handleClose}
				selectLanguageLabel={t.selectLanguage}
				translations={t}
				activeLang={lang}
				onSelect={handleSelect}
			/>
		</>
	);
};

export default LanguageSwitcher;
